export default __webpack_public_path__ + "static/boyz-a14dadcabce3ad5d5922bddae1a43a78.jpg";